/* src/app/features/cobranca/cobranca-detalhe.component.scss */
.moeda {
  text-align: right;
}
/*# sourceMappingURL=cobranca-detalhe.component.css.map */
